import styled from "@emotion/styled";

import UnderlineLink from "shared/components/Links/UnderlineLink";

const YardiConnectionUnderlineLink = styled(UnderlineLink)`
  margin-top: 28px;
`;

export { YardiConnectionUnderlineLink };
